/**
 * 진화 기록 API (docs/features/24-experience-evolution.md) — 사용하면서 배운 것을 보고, 고치고, 끄고, 버린다.
 * LLM 을 부르지 않는 경로다(AI 제외 빌드·내부망에서도 돈다). 모든 항목은 로그인한 사용자 자신의 것이다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/experience`;
const enc = encodeURIComponent;

/** { items, notices, limits: { min, max, repeat }, tasks } */
export async function listItems() { return (await axios.get(`${ROOT}/items`)).data; }
/** 직접 적는 선호 — 바로 적용된다. task 를 주면 그 작업 유형에만 */
export async function addPreference({ text, task }) { return (await axios.post(`${ROOT}/items`, { text, task: task || null })).data; }
/** 고치기 — { text } · { enabled } · { discard: true } · { remove: true } · 제안은 { done: true } · { draft } */
export async function patchItem(id, patch) { return (await axios.put(`${ROOT}/items/${enc(id)}`, patch)).data; }
/** 알림(멈춤·철회·기준 제안)을 봤다 — 머리줄 표시도 함께 끈다 */
export const EVO_SEEN_EVENT = 'livesql:evo-seen';
export async function markSeen() {
  const r = (await axios.post(`${ROOT}/seen`, {})).data;
  try { window.dispatchEvent(new Event(EVO_SEEN_EVENT)); } catch (_e) { /* 표시는 다음 주기에 꺼진다 */ }
  return r;
}
/** 알림 건수만 */
export async function fetchNotices() { return (await axios.get(`${ROOT}/notices`)).data; }
/** 가이드 예외 제안의 초안을 AI 가 쓴다(본인 AI 계정 — 사용자가 누를 때만). 초안은 제안 항목에 남는다 */
export async function draftProposal(id, { signal } = {}) { return (await axios.post(`${BASE_URL}/assistant/experience/proposals/${enc(id)}/draft`, {}, { signal })).data; }

// ── 반출 · 반입 · 병합(4단계) ──
/** 내보내기 — 암호는 본문으로만 보낸다(주소·로그에 남지 않게). { file, counts, encrypted } */
export async function exportExperience({ sections, includeEnv, passphrase, label }) { return (await axios.post(`${ROOT}/export`, { sections, includeEnv, passphrase, label })).data; }
/** 파일을 층으로 들인다 — 미적용. 암호 파일인데 암호가 없으면 EXP_IMPORT_NEEDS_PASSPHRASE */
export async function importFile({ raw, passphrase, label }) { return (await axios.post(`${ROOT}/imports`, { raw, passphrase, label })).data; }
/** 내 것과 견준 표 */
export async function previewImport(id) { return (await axios.get(`${ROOT}/imports/${enc(id)}`)).data; }
/** 고른 것만 합친다 */
export async function applyImport(id, choices) { return (await axios.post(`${ROOT}/imports/${enc(id)}/apply`, { choices })).data; }
export async function undoImport(id) { return (await axios.post(`${ROOT}/imports/${enc(id)}/undo`, {})).data; }
/** 이 출처에서 온 것 모두 끄기·켜기 */
export async function setImportEnabled(id, enabled) { return (await axios.put(`${ROOT}/imports/${enc(id)}`, { enabled })).data; }
export async function removeImport(id) { return (await axios.delete(`${ROOT}/imports/${enc(id)}`)).data; }

/** 화면의 기본값 — 끝낸 작업에서 뚜렷이 쏠린 선택(작업 절차 경험). 없으면 {} */
export async function getDefaults(task) { return (await axios.get(`${ROOT}/defaults`, { params: { task } })).data; }
